import { translate } from "app/filters/i18nFilter";
import {
    type ISimpleWarningModalHook,
    useSimpleWarningModal,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/useSimpleWarningModal";

export const useCancelChangesModal = (onCancelChanges: () => void): ISimpleWarningModalHook =>
    useSimpleWarningModal({
        title: translate("llm.prompts.edit.prompts-table.cancel.title"),
        tooltip: translate("llm.prompts.edit.prompts-table.cancel.tooltip"),
        text: translate("llm.prompts.edit.prompts-table.cancel.text"),
        ctaText: translate("common.discard"),
        onSubmit: onCancelChanges,
    });
